<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  let xLabel = ['2019', '2020', '2021', '2022', '2023', '2024'];
  let data=[
    {name:"蜜薯",value:[26,25,28,12,13,10]},
    {name:"龙薯",value:[4,2,0,0.5,2,0]},
    {name:"西瓜红",value:[7,9,8,5,5.5,8.5]},
    {name:"济薯",value:[0,0,0,0.5,0.1,0]},
    {name:"烟薯",value:[33,29,26,48,54,59]},
  ]

  const option= {
    color: ['#1FFFF7', '#FAB943', '#733884', '#2C9AFB', '#FFDC44'],
    tooltip: {
      trigger: 'axis',
      // backgroundColor: 'rgba(0,0,0,0.5)',
      // borderColor: '#34CEFFBD',
      borderWidth: 2,
      padding: [5, 10],
      textStyle: {
        fontSize: 26
      },
      formatter: (params) => {
          // console.log('params',params)
          let str = `${params[0].name}年<br/>`;
          //seriesName color value
          for (let i = 0; i < params.length; i++) {
              str =
                  str +
                  `<span style='display:inline-block;margin-right:5px;
              border-radius:10px;width:9px;height:9px;background-color:${params[i].color}'></span>
              ${params[i].seriesName}：<i style='float:right;color:${params[i].color}' >${params[i].value}%</i><br/>`;
          }
          return str;
      },
    },
    legend: {
      align: 'left',
      right: '10%',
      top: '5%',
      type: 'plain',
      textStyle: {
        color: '#fff',
        fontSize: 26,
      },
      icon:'circle',
      itemGap: 30,
      itemWidth: 18,
      // icon: 'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
    },
    grid: {
      top: '18%',
      left: '5%',
      right: '10%',
      bottom: '5%',
      // containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '',
        nameGap: 10,
        boundaryGap: false,
        nameTextStyle: {
          // ---坐标轴名称样式
          color: '#E2E8EDE8',
          fontSize: 26,
        },
        axisLabel: {
          show: true,
          interval: 0, //横轴信息全部显示
          // rotate:-30,//-30度角倾斜显示
          textStyle: {
            color: '#E2E8EDE8', // 更改坐标轴文字颜色
            fontSize:26 // 更改坐标轴文字大小
          },
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#379E98AB',
          },
        },
        axisTick: {
          show: false,
        },
        data: xLabel,
      },
    ],
    yAxis: [
      {
        splitLine: {
          show: true,
          lineStyle: {
            type: [5,10],
            dashOffset: 10,
            color: 'rgba(18,130,200,.8)',
            fontSize:30
          }
        },
        axisLabel: {
          show: true,
          interval: 0, //横轴信息全部显示
          textStyle: {
            color: 'rgba(255,255,255,.5)', // 更改坐标轴文字颜色
            fontSize:26 // 更改坐标轴文字大小
          },
          formatter: function(value) {
            // 当值为 0 时不显示标签
            return value === 0 ? '' : value;
          }
        },
      },
    ],
    series: [
      {
        name: data[0].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 10,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 1,
        },
        tooltip: {
          show: true,
        },
        data: data[0].value,
      },
      {
        name: data[1].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize:10,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: data[1].value,
      },
      {
        name: data[2].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 10,
        smooth: true,
        lineStyle: {
          normal: {
            width: 6,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: data[2].value,
      },
      {
        name: data[3].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 10,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: data[3].value,
      },
      {
        name: data[4].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 10,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: data[4].value,
      },
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
